import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';

export const useFetchCategories = ({marvarApi, dispatch, onLogout}) => {

    // 1. Para los datos recuperados de la BD
    const [ dataCategories, setDataCategories ] = useState([])
    
    // 2. Para mostrar animación de carga
    const [ loadingFetchAllCategories, setLoadingFetchAllCategories ] = useState(false)

    // 3. Para ejecutar el fetch desde alguna acción
    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const fetchData = async () => {
        
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            
            const response = await marvarApi.get(`/cashier-managements/admin/categories`)
            // console.log('[useFetch][useFetchCategories] response.data :::', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        setLoadingFetchAllCategories(true)
        fetchData()
            .then((resp) => {
                setDataCategories(resp.rows)
                setLoadingFetchAllCategories(false)
            })
            .catch(e => {
                console.log(e, '________ERROR')
                setLoadingFetchAllCategories(false)
            })
    }, [execute])

    return {  dataCategories, loadingFetchAllCategories , executeFetch }

}

export const useFetchAllCashRegisters = ({ marvarApi, dispatch, onLogout }) => {

    const _defaultParams = {
        idcategoria: '',
        currency_type: '',
    }
    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)

    const [ dataCashRegisters, setDataCashRegisters ] = useState([])

    const [ loadingFetchCashRegisters, setLoadingFetchCashRegisters ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataCashRegisters([])
        setParamsToSearch(_defaultParams)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const _body = {
                idcategoria: parseInt(paramsToSearch.idcategoria, 10),
                currency_type: String(paramsToSearch.currency_type)
            }
            const response = await marvarApi.post(`/caja/fetch-cashier-by-category-currency`, _body)
            // console.log('[useFetchData][useFetchAllCashRegisters] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (
            paramsToSearch.idcategoria > 0 
            && paramsToSearch.idcategoria !== ''
            && paramsToSearch.currency_type !== ''
        ) {
            setLoadingFetchCashRegisters(true)
            fetchData()
                .then((resp) => {
                    setDataCashRegisters(resp.rows)
                    setLoadingFetchCashRegisters(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchCashRegisters(false)
                })
        }
    }, [execute])

    return { dataCashRegisters, loadingFetchCashRegisters, setParamsToSearch, executeFetch, resetFetch }
}

export const useFetchManagementType = ({ marvarApi, dispatch, onLogout }) => {

    const _defaultParams = {
        idcategoria: ''
    }
    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)

    const [ dataManagemetType, setDataManagementType ] = useState([])

    const [ loadingFetchManagementType, setLoadingFetchManagementType ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataManagementType([])
        setParamsToSearch(_defaultParams)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/cashier-managements/managements-type-by-category/${paramsToSearch.idcategoria}`)
            // console.log('[useFetchData][useFetchManagementType] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (
            paramsToSearch.idcategoria > 0 
            && paramsToSearch.idcategoria !== ''
            && paramsToSearch.currency_type !== ''
        ) {
            setLoadingFetchManagementType(true)
            fetchData()
                .then((resp) => {
                    setDataManagementType(resp.rows)
                    setLoadingFetchManagementType(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchManagementType(false)
                })
        }
    }, [execute])

    return { dataManagemetType, loadingFetchManagementType, setParamsToSearch, executeFetch, resetFetch }
}

export const useFetchSpecificManagement = ({ marvarApi, dispatch, onLogout, paramsURL, Forms }) => {
    
    const { idgestion } = paramsURL

    const { FormScreen } = Forms
    const { formState, setFormState } = FormScreen

    const [ dataOperationDetail, setDataOperationDetail ] = useState([])

    const [ loadingFetchOperationDetail, setLoadingFetchOperationDetail ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataOperationDetail([])
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const response = await marvarApi.get(`/cashier-managements/fetch-specific-management/${idgestion}`)
            console.log('[useFetchData][useFetchSpecificManagement] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if(idgestion && idgestion > 0 && idgestion !== ''){
            setLoadingFetchOperationDetail(true)
            fetchData()
                .then((resp) => {
                    setDataOperationDetail(resp.rows)
                    setFormState((prevState) => ({
                        ...prevState,
                        // auxiliares
                        idcategoria: resp.rows[0].idcategoria,
                        currency_type: resp.rows[0].currency_type,
                        // campos
                        idgestion: resp.rows[0].idgestion || '',
                        idgestiontipo: resp.rows[0].idgestiontipo || '',
                        idcaja: resp.rows[0].idcaja || '',
                        idusuario: resp.rows[0].idusuario || '',
                        idcaja_destino: resp.rows[0].idcaja_destino || '',
                        idbanco: resp.rows[0].idbanco || '',
                        numero_comprobante: resp.rows[0].numero_comprobante || '',
                        numero_serie_factura: resp.rows[0].numero_serie_factura || '',
                        monto_solicitado: resp.rows[0].monto_solicitado || '',
                        monto_solicitado_mask: 
                            parseFloat(resp.rows[0].monto_solicitado)
                                .toLocaleString('en-US', {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) || '',
                        monto_aprobado: resp.rows[0].monto_aprobado || '',
                        monto_aprobado_mask: 
                            parseFloat(resp.rows[0].monto_aprobado)
                                .toLocaleString('en-US', {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) || '',
                        tipo_cambio: resp.rows[0].tipo_cambio || '',
                        tipo_cambio_mask:
                            parseFloat(resp.rows[0].tipo_cambio)
                                .toLocaleString('en-US', {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) || '',
                        monto_convertido: resp.rows[0].monto_convertido || '',
                        monto_convertido_mask:
                            parseFloat(resp.rows[0].monto_convertido)
                                .toLocaleString('en-US', {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) || '',
                        descripcion_servicio: resp.rows[0].descripcion_servicio || '',
                        limite_pago_servicio: resp.rows[0].limite_pago_servicio || '',
                        limite_pago_servicio_mask: 
                            parseFloat(resp.rows[0].limite_pago_servicio)
                                .toLocaleString('en-US', {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) || '',
                        descripcion: resp.rows[0].descripcion || '',
                        aprobacion_check: resp.rows[0].aprobacion_check || '',
                        aprobacion_usuario: resp.rows[0].aprobacion_usuario || '',
                        aprobacion_fecha: resp.rows[0].aprobacion_fecha || '',
                        aprobacion_observaciones: resp.rows[0].aprobacion_observaciones || '',
                        attachments: resp.rows[0].attachments
                    }))
                    setLoadingFetchOperationDetail(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setDataOperationDetail([])
                    setLoadingFetchOperationDetail(false)
                })
        }
    }, [execute])

    return { dataOperationDetail, loadingFetchOperationDetail, executeFetch, resetFetch }
}

export const useFetchCashierByCategory = ({ marvarApi, dispatch, onLogout }) => {

    const _defaultParams = {
        idcategoria: '',
        currency_type: '',
    }
    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)

    const [ dataCashierByCategory, setDataCashierByCategory ] = useState([])

    const [ loadingFetchCashierByCategory, setLoadingFetchCashierByCategory ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataCashierByCategory([])
        setParamsToSearch(_defaultParams)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const _body = {
                idcategoria: parseInt(paramsToSearch.idcategoria, 10),
                currency_type: String(paramsToSearch.currency_type)
            }
            const response = await marvarApi.post(`/caja/fetch-cashier-by-category-currency`, _body)
            console.log('[useFetchData][useFetchCashierByCategory] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (
            paramsToSearch.idcategoria > 0 
            && paramsToSearch.idcategoria !== ''
            && paramsToSearch.currency_type !== ''
        ) {
            setLoadingFetchCashierByCategory(true)
            fetchData()
                .then((resp) => {
                    setDataCashierByCategory(resp.rows)
                    setLoadingFetchCashierByCategory(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setLoadingFetchCashierByCategory(false)
                })
        }
    }, [execute])

    return { dataCashierByCategory, loadingFetchCashierByCategory, setParamsToSearch, executeFetch, resetFetch }
}

export const useFetchBanksByCurrency = ({ marvarApi, dispatch, onLogout }) => {

    const _defaultParams = {
        currency_type: ''
    }
    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)

    const [ dataBanksByCurrency, setDataBanksByCurrency ] = useState([])

    const [ loadingFetchBanksByCurrency, setLoadingFetchBanksByCurrency ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataBanksByCurrency([])
        setParamsToSearch(_defaultParams)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const _body = {
                currency_type: String(paramsToSearch.currency_type)
            }
            const response = await marvarApi.post(`/cashier-managements/fetch-banks-by-currency`, _body)
            console.log('[useFetchData][useFetchBanksByCurrency] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (paramsToSearch.currency_type !== '') {
            setLoadingFetchBanksByCurrency(true)
            fetchData()
                .then((resp) => {
                    setDataBanksByCurrency(resp.rows)
                    setLoadingFetchBanksByCurrency(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setDataBanksByCurrency([])
                    setLoadingFetchBanksByCurrency(false)
                })
        }
    }, [execute])

    return { dataBanksByCurrency, loadingFetchBanksByCurrency, setParamsToSearch, executeFetch, resetFetch }
}

// export const useFetchAllServicePayable = ({marvarApi, dispatch, onLogout}) => {

//     // 1. Para los datos recuperados de la BD
//     const [ dataServicePayable, setDataServicePayable ] = useState([])
    
//     // 2. Para mostrar animación de carga
//     const [ loadingFetchServicePayable, setLoadingFetchServicePayable ] = useState(false)

//     // 3. Para ejecutar el fetch desde alguna acción
//     const [ execute, setExecute ] = useState(false)
//     const executeFetch = async () => {
//         setExecute(!execute)
//     }

//     const fetchData = async () => {
        
//         // validamos el token
//         const token = localStorage.getItem('token')
//         if (!token) return dispatch(onLogout())

//         try {
            
//             const response = await marvarApi.get(`/cashier-managements/service-payable`)
//             // console.log('[useFetch][useFetchAllServicePayable] response.data :::', response.data)
//             return response.data
//         } catch (e) {
//             console.log(e)
//         }
//     }

//     useEffect(() => {
//         setLoadingFetchServicePayable(true)
//         fetchData()
//             .then((resp) => {
//                 setDataServicePayable(resp.rows)
//                 setLoadingFetchServicePayable(false)
//             })
//             .catch(e => {
//                 console.log(e, '________ERROR')
//                 setDataServicePayable([])
//                 setLoadingFetchServicePayable(false)
//             })
//     }, [execute])

//     return {  dataServicePayable, loadingFetchServicePayable , executeFetch }

// }

export const useFetchAllCashierByCurrencyType = ({ marvarApi, dispatch, onLogout }) => {

    const _defaultParams = {
        idcategoria: '',
        currency_type: '',
    }
    const [ paramsToSearch, setParamsToSearch ] = useState(_defaultParams)

    const [ dataCashierByCurrencyType, setDataCashierByCurrencyType ] = useState([])

    const [ loadingFetchCashierByCurrencyType, setLoadingFetchCashierByCurrencyType ] = useState(false)

    const [ execute, setExecute ] = useState(false)
    const executeFetch = async () => {
        setExecute(!execute)
    }

    const resetFetch = async () => {
        setDataCashierByCurrencyType([])
        setParamsToSearch(_defaultParams)
    }

    const fetchData = async () => {
        // validamos el token
        const token = localStorage.getItem('token')
        if (!token) return dispatch(onLogout())

        try {
            const _body = {
                idcategoria: parseInt(paramsToSearch.idcategoria, 10),
                currency_type: String(paramsToSearch.currency_type)
            }
            const response = await marvarApi.post(`/caja/fetch-cashier-by-category-currency`, _body)
            // console.log('[useFetchData][useFetchAllCashierByCurrencyType] response.data ::: ', response.data)
            return response.data
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        if (
            paramsToSearch.idcategoria > 0 
            && paramsToSearch.idcategoria !== ''
            && paramsToSearch.currency_type !== ''
        ) {
            setLoadingFetchCashierByCurrencyType(true)
            fetchData()
                .then((resp) => {
                    setDataCashierByCurrencyType(resp.rows)
                    setLoadingFetchCashierByCurrencyType(false)
                })
                .catch(e => {
                    console.log(e, '________ERROR')
                    setDataCashierByCurrencyType([])
                    setLoadingFetchCashierByCurrencyType(false)
                })
        }
    }, [execute])

    return { dataCashierByCurrencyType, loadingFetchCashierByCurrencyType, setParamsToSearch, executeFetch, resetFetch }
}